<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/hc-as-sri-lanka-sigiriya-lions-rock-fortress-620824600-g-rf-cc-only-1920-x-1080.png') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">Thanks for <br> Travel with us</h1>
                    <p class="para-desc text-white-50">Launch your campaign and benefit from our expertise on designing
                        and
                        managing conversion centered bootstrap4 html page.</p>
                    <div class="mt-4">
                        <a href="javascript:void(0)" class="btn btn-icon btn-pills btn-lg btn-light">
                            <i-feather name="arrow-down" class="icons"></i-feather>
                        </a>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="card login_page shadow rounded border-0 ml-lg-5">
                    <div class="card-body">
                        <h5 class="card-title">You can start search here</h5>

                        <form [formGroup]="reviewForm" class="login-form">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Full Name</label>
                                        <i-feather name="user" class="fea icon-sm icons"></i-feather>
                                        <input type="text" class="form-control pl-5" placeholder="Name" name="s" formControlName="name"
                                               required="">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Your Email</label>
                                        <i-feather name="mail" class="fea icon-sm icons"></i-feather>
                                        <input type="email" class="form-control pl-5" placeholder="Email" name="email" formControlName="email"
                                               required="">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Review</label>
                                        <i-feather name="info" class="fea icon-sm icons"></i-feather>
                                        <input type="email" class="form-control pl-5" placeholder="Review" name="email" formControlName="review"
                                               required="">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Rate</label>
                                        <br>
                                        <ngb-rating [(rate)]="currentRate">
                                            <ng-template let-fill="fill" let-index="index">
                                                <span class="star" [class.filled]="fill === 100">&#9733;</span>
                                            </ng-template>
                                        </ngb-rating>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <button class="btn btn-success w-100" (click)="reveiw()">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="row justify-content-center">
    <div class="col-lg-12 mt-4">
        <owl-carousel-o id="customer-testi" [options]="testiOptions">
            <ng-template carouselSlide *ngFor="let r of review">
                <div class="media customer-testi m-2">
                    <img src="assets/images/user/user-3331257__340.png"
                         class="avatar avatar-small mr-3 rounded shadow"
                         alt="">
                    <div class="media-body content p-3 shadow rounded bg-white position-relative">
                        <ul class="list-unstyled mb-0">
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                        </ul>
                        <p class="text-muted mt-2">"{{r.review}} "</p>
                        <h6 class="text-primary">{{r.clientName}} </h6>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
        <!-- </div> -->
    </div>
    <!--end col-->
</div>
